/* INSPIRE theme — interactions (vanilla, no dependencies) */
(function () {
  'use strict';

  /* Mobile nav */
  var toggle = document.querySelector('[data-nav-toggle]');
  var nav = document.querySelector('[data-mobile-nav]');
  var close = document.querySelector('[data-nav-close]');
  function openNav() { if (nav) { nav.setAttribute('data-open', ''); document.body.style.overflow = 'hidden'; } }
  function closeNav() { if (nav) { nav.removeAttribute('data-open'); document.body.style.overflow = ''; } }
  if (toggle) toggle.addEventListener('click', openNav);
  if (close) close.addEventListener('click', closeNav);
  if (nav) nav.querySelectorAll('a').forEach(function (a) { a.addEventListener('click', closeNav); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeNav(); });

  /* Accordions */
  document.querySelectorAll('[data-acc]').forEach(function (item) {
    var q = item.querySelector('.acc__q');
    var a = item.querySelector('.acc__a');
    if (!q || !a) return;
    q.addEventListener('click', function () {
      var open = item.hasAttribute('data-open');
      if (open) { item.removeAttribute('data-open'); a.style.maxHeight = null; }
      else { item.setAttribute('data-open', ''); a.style.maxHeight = a.scrollHeight + 'px'; }
    });
  });

  /* Scroll reveal */
  var reveals = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window && reveals.length) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { threshold: 0.12 });
    reveals.forEach(function (el) { io.observe(el); });
  } else {
    reveals.forEach(function (el) { el.classList.add('is-in'); });
  }

  /* Product variant + gallery selection (PDP) */
  var pdp = document.querySelector('[data-product-form]');
  if (pdp) {
    var variantData = {};
    try { variantData = JSON.parse(document.querySelector('[data-variants]').textContent); } catch (e) {}
    var idInput = pdp.querySelector('[data-variant-id]');
    var priceEl = document.querySelector('[data-current-price]');
    var addBtn = pdp.querySelector('[data-add]');
    function currentOptions() {
      return Array.prototype.map.call(pdp.querySelectorAll('[data-option]:checked'), function (i) { return i.value; });
    }
    function matchVariant() {
      var opts = currentOptions();
      return variantData.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });
    }
    function refresh() {
      var v = matchVariant();
      if (!v) return;
      if (idInput) idInput.value = v.id;
      if (priceEl && v.priceFormatted) priceEl.textContent = v.priceFormatted;
      if (addBtn) {
        if (v.available) { addBtn.removeAttribute('disabled'); addBtn.textContent = addBtn.getAttribute('data-add-label') || 'Add to cart'; }
        else { addBtn.setAttribute('disabled', ''); addBtn.textContent = 'Sold out'; }
      }
    }
    pdp.querySelectorAll('[data-option]').forEach(function (i) { i.addEventListener('change', refresh); });
    refresh();
  }

  /* Product Tabs */
  document.querySelectorAll('.product-tabs__trigger').forEach(function (trigger) {
    trigger.addEventListener('click', function () {
      var tabId = trigger.getAttribute('data-tab');
      var container = trigger.closest('[data-tabs]');
      if (!container || !tabId) return;
      
      /* Remove selected state from all triggers */
      container.querySelectorAll('.product-tabs__trigger').forEach(function (t) {
        t.setAttribute('aria-selected', 'false');
      });
      
      /* Remove selected state from all panels */
      container.querySelectorAll('.product-tabs__panel').forEach(function (p) {
        p.removeAttribute('data-selected');
      });
      
      /* Add selected state to this trigger */
      trigger.setAttribute('aria-selected', 'true');
      
      /* Add selected state to corresponding panel */
      var panel = container.querySelector('[data-panel="' + tabId + '"]');
      if (panel) panel.setAttribute('data-selected', '');
    });
  });

  /* Lazy Loading Images */
  if ('IntersectionObserver' in window) {
    var lazyImages = document.querySelectorAll('img[loading="lazy"]');
    var imgObserver = new IntersectionObserver(function (entries, observer) {
      entries.forEach(function (en) {
        if (en.isIntersecting) {
          var img = en.target;
          img.src = img.dataset.src || img.src;
          img.classList.add('lazy-loaded');
          observer.unobserve(img);
        }
      });
    }, { rootMargin: '50px' });
    lazyImages.forEach(function (img) { imgObserver.observe(img); });
  }

  /* Quick View Modal Setup */
  document.querySelectorAll('[data-quick-view]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      var url = btn.getAttribute('href');
      if (url) window.location.href = url;
    });
  });

  /* Mobile Menu State Management */
  var mobileMenuState = false;
  if (toggle) {
    toggle.addEventListener('click', function () {
      mobileMenuState = !mobileMenuState;
      if (nav) nav.classList.toggle('active', mobileMenuState);
    });
  }
  if (close) {
    close.addEventListener('click', function () {
      mobileMenuState = false;
      if (nav) nav.classList.remove('active');
    });
  }

  /* Stock Indicator */
  document.querySelectorAll('[data-stock]').forEach(function (el) {
    var count = parseInt(el.getAttribute('data-stock'), 10);
    var indicator = el.querySelector('.stock-indicator');
    if (indicator) {
      if (count === 0) {
        indicator.className = 'stock-indicator stock-low';
        indicator.textContent = 'Out of stock';
      } else if (count < 5) {
        indicator.className = 'stock-indicator stock-low';
        indicator.textContent = 'Only ' + count + ' left in stock';
      } else {
        indicator.className = 'stock-indicator stock-in';
        indicator.textContent = 'In stock';
      }
    }
  });

  /* Newsletter Form Enhancement */
  document.querySelectorAll('[data-newsletter-form]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      var email = form.querySelector('input[type="email"]');
      if (email && email.value) {
        var discount = form.getAttribute('data-discount');
        if (discount && window.localStorage) {
          localStorage.setItem('inspire_discount', discount);
        }
      }
    });
  });
})();
